import callAcceptInvite from '../api/acceptInvite';
import { callApi } from '../../util';

export default function* acceptInvite(token: string) {
  yield callApi('organization/acceptInvite::SILENT', callAcceptInvite, token);
}
